import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { autoChecklistService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGVerifyGAuthenticateReRunMutationProps = {
	id: number;
	onSuccessHandler?: Function;
};

const useGVerifyGAuthenticateReRunMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id }: useGVerifyGAuthenticateReRunMutationProps) =>
			autoChecklistService.reRunGVerifyGAuthenticate(id),
		{
			onSuccess(_, { onSuccessHandler }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "gVerify & gAuthenticate re-run was successful",
					}),
				);
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useGVerifyGAuthenticateReRunMutation;
